import chartererTypeHeading from '../chartererType/chartererTypeHeading';

const ownerTypeHeading = {
    ...chartererTypeHeading,
    colId: 'ownerType',
    headerName: 'Owner Type',
    field: 'ownerType',
};

export default ownerTypeHeading;
